import React, { useState } from "react";
import classNames from "classnames";
import { Collapse } from "reactstrap";
import SidebarItem from "./SidebarItem";

const SubMenu = (props) => {
    const [collapsed, setCollapsed] = useState(true);
    const toggle = () => setCollapsed(!collapsed);
    const { icon, title, items } = props;

    return (
        <>

            <SidebarItem text={title} icon={icon} onClick={toggle} submenu collapsed={collapsed} />


            <Collapse
                isOpen={!collapsed}
                navbar
                className={classNames("items-menu", { "mb-0": !collapsed })}
            >
                {items.map((item, index) => {

                    return (
                        <SidebarItem key={index} text={item.name} link={item.path} icon={item.icon} active={item.active} subItem />
                    )
                }
                )}
            </Collapse>
        </>
    );
};

export default SubMenu;
